import * as _ from 'ramda'

export default {
  data () {
    return {
      currentErrorDiscription: '',
      errorDiscription: {
        NotReadableError: `
          미디어 기기의 정보를 읽어 올 수 있는 상태가 아닙니다. 
          1. 다른 응용프로그램에서 미디어 기기를 사용중인지 확인하고 해지세요.
          2. 브라우저의 주소표시창 옆에 카메라 아이콘을 클릭하고 사용되는 기기를 확인하세요.
          그리고 브라우저의 설정 > 카메라 혹은 설정 > 마이크에서 다른 기기를 선택후 다시 시도해보세요.
        `,
        UserMediaDeviceFailedError: `
          미디어를 가져오는데 실패하였습니다.
          방송 생성시 지원되는 해상도, 지원되는 기능을 설정했는지 다시한번 확인하세요.
        `,
        unknownError: `
          알려지지 않은 오류가 발생했습니다. 관리자에게 문의하세요.
        `
      }
    }
  },

  computed: {
  },

  methods: {
    setCurrentError (errName) {
      _.has(errName)(this.errorDiscription)
        ? this.currentErrorDiscription = this.errorDiscription[errName]
        : this.currentErrorDiscription = this.errorDiscription.unknownError
    },

    showAlert ({
      error,
      currentErrorDiscription = this.setCurrentError(error.name), // currentErrorDiscription is not need just dummy
      title = '예기치 않은 문제가 발생했습니다',
      messageHtml = `
        <p class="small">${error.name}</p>
        <p class="small">${error.message}</p>
        <hr>
        <p>${this.currentErrorDiscription.replace(/\n/g, '<br>')}</p>
      `,
      buttons = [
        {
          title: '페이지를 다시 로드하기',
          default: true,
          handler () {
            window.location.href = '/'
          }
        }
      ]
    }) {
      this.$modal.show('dialog', {
        title,
        text: messageHtml,
        buttons
      })
    }
  }
}
